
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.945 11v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.945.72V.336H5.22c.828 0 1.492.088 1.992.266.505.177.88.44 1.125.789.245.343.367.789.367 1.336 0 .453-.088.846-.265 1.18-.172.333-.399.609-.68.827a4.857 4.857 0 01-1.086.61v.07c.708.214 1.245.544 1.61.992.364.443.546.972.546 1.586 0 .709-.159 1.287-.476 1.735-.313.447-.753.773-1.32.976-.568.198-1.256.297-2.063.297H.945zm3.743-5.883c.791 0 1.395-.19 1.812-.57.422-.386.633-.943.633-1.672 0-.36-.06-.656-.18-.89a1.402 1.402 0 00-.484-.57 1.942 1.942 0 00-.727-.298 4.211 4.211 0 00-.914-.094c-.198 0-.458.006-.781.016s-.565.02-.727.031v4.047h1.368zm-1.368 5.14c.38.037.805.056 1.274.056.682 0 1.21-.086 1.586-.258.38-.172.653-.425.82-.758.172-.339.258-.76.258-1.266 0-.505-.094-.922-.281-1.25-.183-.328-.467-.573-.852-.734-.385-.162-.917-.242-1.594-.242h-1.21v4.453z","fill":"currentColor"}})])
          )
        }
      }
    